export default "__VITE_ASSET__Bny4LHTy__"